import { render } from "./BannerBind.vue?vue&type=template&id=19a503b3&scoped=true"
import script from "./BannerBind.vue?vue&type=script&lang=js"
export * from "./BannerBind.vue?vue&type=script&lang=js"

import "./BannerBind.vue?vue&type=style&index=0&id=19a503b3&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a503b3"]])

export default __exports__